import { FC } from 'react';
import { useCurrentUser } from '@hooks/users';
import { useGetBillingInfoQuery, useUpdateSubscriptionDayMutation } from '@teachur/http-client';
import { useStripeCard } from './useStripeCard';
import { BillingInfoForm } from './BillingInfoForm';
import { InvoicesSection } from './InvoicesSection';
import { Loader } from '@new/common/ui/Loader/Loader';
import { toast } from 'react-toastify';

export const BillingInfoSection: FC = () => {
  const { data: user, isLoading: isUserLoading } = useCurrentUser();

  const {
    data: billingInfo,
    isLoading: isBillingInfoLoading,
    isError: isBillingInfoError,
  } = useGetBillingInfoQuery();

  const { mutate: updateSubscriptionDay } = useUpdateSubscriptionDayMutation({
    onSuccess: () => toast.success('Subscription day updated successfully.'),
    onError: () => toast.error('Failed to update subscription day.'),
  });
  const { addCard, isPending: isAddingCard } = useStripeCard();

  const isLoading = isUserLoading || isBillingInfoLoading;

  return (
    <div className="flex flex-col gap-6">
      {/* <SectionHeading>Billing Info</SectionHeading> */}

      {isLoading && (
        <div className="flex items-center justify-center py-10">
          <Loader />
        </div>
      )}

      {!isLoading && (isBillingInfoError || !billingInfo || !user) && (
        <div className="rounded-lg border border-(--warning-W700) bg-(--warning-W200) p-5">
          <p className="m-0! [font-size:var(--fs-p3)]! font-medium text-(--warning-W700)!">
            No subscription found. Please choose a subscription plan to manage your billing
            information.
          </p>
        </div>
      )}

      {!isLoading && !isBillingInfoError && billingInfo && user && (
        <>
          <BillingInfoForm
            user={user}
            billingInfo={billingInfo}
            onUpdateSubscriptionDay={updateSubscriptionDay}
            onAddCard={addCard}
            isAddingCard={isAddingCard}
          />

          <InvoicesSection payments={billingInfo?.payments ?? []} />
        </>
      )}
    </div>
  );
};
